import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugEscitalopram} from "./TextDrugEscitalopram"


export default function Escitalopram() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
   
    <ButtonsText onClick={handleOpen} name='Escitalopram' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Escitalopram - PGx Recommendation"
        content={ <TextDrugEscitalopram />}

        />

</>
)}